export default __webpack_public_path__ + "static/media/3x4.dd2c2ee2.PNG";